var Model = require('../Model');

var Site = Object.create(Model);

Site.name = 'Site';
Site['@class'] = 'Site';
Site.url = 'site';
Site.parentClass = 'Location';
Site.fields = {
  name:{
    type: 'text',
    default: null,
    validators: {
      presence: true, 
      length: {minimum: 1, maximum: 32, default: ''},
    }
  },
  streetAddress:{
    type: 'text',
    default: '',
  },
  latitude:{
    type: 'number',
    default: '',
  },
  longitude:{
    type: 'number',
    default: '',

  },
  geojson : {
    type: 'textarea',
    default: null,
  },
  preferredNumberOfRows:{}
};

module.exports = Site;
